<template>
  <transition v-bind="modalTransition">
    <div v-if="isOpen" class="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
      <div class="mx-auto max-w-lg bg-white p-6 shadow-4">
        <div class="mb-4 flex items-center justify-between">
          <h2 class="text-xl font-semibold">{{ isEditing ? 'Editar' : 'Novo' }} tipo de classificação</h2>
          <button type="button" @click="cancel" class="hover:text-slate-400">
            <IcClose />
          </button>
        </div>
        <form @submit.prevent="handleSave">
          <div class="mb-4">
            <label for="name" class="block text-sm font-medium">Nome</label>
            <input
              v-model="name"
              type="text"
              id="name"
              class="mt-1 block w-full border border-bodydark2 px-3 py-2 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
              placeholder="Ex: Manutenção programada" />
            <div v-if="errors.name" class="mt-1 text-sm text-red">{{ errors.name }}</div>
          </div>
          <div class="mb-4">
            <label for="nature" class="block text-sm font-medium">Natureza</label>
            <select
              v-model="nature"
              id="nature"
              class="mt-1 block w-full border border-bodydark2 bg-white px-3 py-2 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm">
              <option v-for="option in CLASSIFICATION_TYPE_NATURE_OPTIONS" :key="option.value" :value="option.value">
                {{ option.label }}
              </option>
            </select>
            <div v-if="errors.nature" class="mt-1 text-sm text-red">{{ errors.nature }}</div>
          </div>
          <div class="mt-6 flex justify-end gap-4">
            <button type="button" @click="cancel" class="px-4 py-2 text-slate-500 hover:text-slate-400">
              Cancelar
            </button>
            <button
              type="submit"
              class="border border-primary bg-primary px-4 py-2 text-sm font-medium text-white transition hover:bg-primary/90">
              <span v-if="isLoading">
                <ButtonLoader />
              </span>
              <span v-else>{{ isEditing ? 'Salvar' : 'Criar' }}</span>
            </button>
          </div>
        </form>
      </div>
    </div>
  </transition>
</template>

<script setup lang="ts">
import { computed, ref, watch } from 'vue'
import IcClose from '@/components/Icons/IcClose.vue'
import ButtonLoader from '@/components/Globals/Feedbacks/ButtonLoader.vue'
import { modalTransition } from '@/plugins/transitions'
import { CLASSIFICATION_TYPE_NATURE_OPTIONS } from '@/interfaces/enums'

const props = defineProps<{
  isOpen: boolean
  initialName?: string
  initialNature?: string | null
  editingId?: number | null
}>()

const emit = defineEmits<{
  close: []
  saved: [name: string, nature: string | null]
}>()

const name = ref('')
const nature = ref('')
const errors = ref<Record<string, string>>({})
const isLoading = ref(false)

const isEditing = computed(() => !!props.editingId)

watch(
  () => props.isOpen,
  (open) => {
    if (open) {
      name.value = props.initialName ?? ''
      nature.value = props.initialNature ?? ''
      errors.value = {}
    }
  },
)

function cancel() {
  emit('close')
}

async function handleSave() {
  errors.value = {}
  const trimmed = name.value?.trim()
  if (!trimmed) {
    errors.value.name = 'Nome é obrigatório'
    return
  }

  isLoading.value = true
  try {
    emit('saved', trimmed, nature.value || null)
    emit('close')
  } finally {
    isLoading.value = false
  }
}
</script>
